var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-sports-baseball",
    clipPath: "url(#clip0_695_2027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.74063 5.48047C1.28143 7.55407 0.423828 10.0757 0.423828 12.8021C0.423828 15.5285 1.28143 18.0501 2.74063 20.1237C5.83823 19.1381 8.10383 16.2325 8.10383 12.8021C8.10383 9.37167 5.83823 6.46607 2.74063 5.48047ZM23.707 5.48047C20.6094 6.46607 18.3438 9.37167 18.3438 12.8021C18.3438 16.2325 20.6094 19.1381 23.707 20.1237C25.1662 18.0501 26.0238 15.5285 26.0238 12.8021C26.0238 10.0757 25.1662 7.55407 23.707 5.48047Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7844 12.8C15.7844 8.6016 18.306 5.0048 21.9156 3.4176C19.6372 1.3056 16.5908 0 13.2244 0C9.858 0 6.8116 1.3056 4.5332 3.4176C8.1428 5.0048 10.6644 8.6016 10.6644 12.8C10.6644 16.9984 8.1428 20.5952 4.5332 22.1824C6.8116 24.2944 9.858 25.6 13.2244 25.6C16.5908 25.6 19.6372 24.2944 21.9156 22.1824C20.0925 21.3834 18.5417 20.0705 17.4528 18.4042C16.3639 16.738 15.7842 14.7905 15.7844 12.8Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_2027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 25.6,
    fill: "white",
    transform: "translate(0.423828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.4292532c24c2b501aa1360d1677225b2.svg";
export { ForwardRef as ReactComponent };